import { apiClient } from "./client";

const addIfNotEmpty = (obj, key, value) => {
  // "빈값" 기준: undefined, null, 빈 문자열
  if (value === undefined || value === null || value === "") return;
  obj[key] = value;
};

export const apiKVMInstanceCreate = async (
  instanceName,
  image,
  flavor,
  tenant_network,
  storage_network,
  size,
  hostsystem,
  kind,
  ouname,
  username,
  cloud_config
) => {
  const body: any = {};

  addIfNotEmpty(body, "instanceName", instanceName);
  addIfNotEmpty(body, "image", image);
  addIfNotEmpty(body, "flavor", flavor);
  addIfNotEmpty(body, "tenant_network", tenant_network);
  addIfNotEmpty(body, "storage_network", storage_network);
  addIfNotEmpty(body, "hostsystem", hostsystem);
  addIfNotEmpty(body, "size", size);
  addIfNotEmpty(body, "kind", kind);
  addIfNotEmpty(body, "ouname", ouname);
  addIfNotEmpty(body, "username", username);

  if (cloud_config !== undefined && cloud_config !== null) {
    body.cloud_config = cloud_config;
  }

  const data = await apiClient.post("/KVM/instances/create", body, {
    headers: { Accept: "application/json" },
  });

  return data;
};

export const apiKVMInstanceDelete = async (instanceName) => {
  const data = {
    volume: true,
    port: true,
    vm: true,
    db: true,
    ad: true,
  };
  const res = await apiClient.delete(`/KVM/instances/${instanceName}`, {
    data,
    headers: {
      Accept: "application/json",
    },
  });

  return res;
};

export const kvmAPI = {
  hypervisor() {
    return apiClient.get(`/KVM/hypervisors`);
  },
  network() {
    return apiClient.get(`/KVM/networks`);
  },
  flavors() {
    return apiClient.get(`/KVM/flavors`);
  },
  images() {
    return apiClient.get(`/KVM/images`);
  },

  migrate(instanceName, hostname, start) {
    return apiClient.post(`/KVM/instances/${instanceName}/migrate`, {
      hostName: hostname,
      start,
    });
  },
};
